<template>
  <PageBreadcrumb
    :crumbs="[{
      link: '/aste/',
      label: 'Gestione Aste'
    }, {
      label: 'Gestione Lotti Asta ' + auction.name
    }]"
  />

  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
        @click="router.push('/aste/' + auctionId + '/lotti/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Lotto
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <StandardColumn>
          Codice
        </StandardColumn>
        <StandardColumn>
          Quantità
        </StandardColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="lot, index in data"
        :key="'lot-table-tr-' + lot.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ lot.code }}
        </td>

        <td class="p-2">
          {{ lot.quantity }}
        </td>

        <td class="p-2 text-right">
          <a 
            v-if="(index > 0 || hasPrev )&& auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
            href="#"
            title="Sposta su"
            @click.prevent="moveUp(lot)"
          >
            <ArrowSmallUpIcon class="h-5 w-5 inline-block mx-1" />
          </a>
          <a 
            v-if="(index < data.length - 1 || hasNext ) && auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
            href="#"
            title="Sposta giu"
            @click.prevent="moveDown(lot)"
          >
            <ArrowSmallDownIcon class="h-5 w-5 inline-block mx-1" />
          </a>
          <RouterLink
            title="Visualizza Lotto"
            :to="'/aste/' + auctionId + '/lotti/visualizza/' + lot.uuid"
          >
            <DocumentMagnifyingGlassIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <RouterLink
            v-if="auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
            title="Modifica Lotto"
            :to="'/aste/' + auctionId + '/lotti/' + lot.uuid"
          >
            <PencilSquareIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <a
            v-if="auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
            href="#"
            title="Elimina Lotto"
            @click.prevent="destroy(lot)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1" />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>

<script setup>
import {
  ArrowSmallDownIcon,
  ArrowSmallUpIcon,
  DocumentMagnifyingGlassIcon,  PencilSquareIcon,
  PlusCircleIcon,
  TrashIcon} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router';

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import StandardColumn from "@/components/list/StandardColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios.js'
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const search = ref('')

const sortStatus = ref(["position", -1]);

const router = useRouter()
const route = useRoute()
const axios = useAxios()
const authStore = useAuthStore()

const auctionId = route.params.auctionId
const auctionResp = await axios.get('/auction/' + auctionId);
const auction = ref(auctionResp.data);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/lot/list/" + auctionId,
  sortStatus,
  search,
  searchProperties: ['code']
})

const moveUp = (lot) => {
  action('post', 'lot/' + auctionId + '/up/' + lot.uuid, 'Lotto spostato con successo')
}

const moveDown = (lot) => {
  action('post', 'lot/' + auctionId + '/down/' + lot.uuid, 'Lotto spostato con successo')
}

const destroy = (lot) => {
  action('delete', 'lot/' + lot.uuid, 'Lotto eliminato con successo')
}
</script>
